import React, { useEffect, useState } from "react";
import { SettingOutlined } from "@ant-design/icons";
import { useTheme } from "../../utils/ThemeContext";
import DashboardInvestmentTableComponent from "./DashboardInvestmentTableComponent";
import DASHBOARD_API from "../../apis/dashboard.api";
import NewLoader from "../styled-components/loader/NewLoader";

const headers = ["Company", "Ticker", "Last", "Chg", "Chg %", ""];

const InvestmentWatchlistTable = () => {
  const { theme } = useTheme();
  const [loading, setLoading] = useState(false);
  const [storedStocksList, setStoredStocksList] = useState([]);

  const getStoredDocuments = async () => {
    try {
      setLoading(true)
      const response = await DASHBOARD_API.fetchStocks();
      console.log("stocks listings==>", response.data.rows);

      if (response && response.data) {
        setStoredStocksList(response.data.rows);
      }
      setLoading(false)
    } catch (error) {
      console.log("error while getting stock list==>", error);
      setLoading(false)

    }
  };

  useEffect(() => {
    getStoredDocuments();
  }, []);
  return (
    <div style={{ position:"relative",}}>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: theme === "dark" ? "#232323" : "white",
        }}
      >
        <h3
          style={{
            color: theme === "light" ? "#232323" : "white",
          }}
        >
          Investment Watchlist
        </h3>
        <SettingOutlined />
      </div>
      <DashboardInvestmentTableComponent
        theme={theme}
        headers={headers}
        data={storedStocksList}
      />
      <NewLoader isLoading={loading}/>
    </div>
  );
};

export default InvestmentWatchlistTable;
